import _ from 'lodash';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import * as core from '@/core';
import { translate } from '@/i18n';
import * as coreBi from '@/coreBi';
import React from 'react';
import { Divider } from '@wix/wix-base-ui';
import * as baseUI from '@/baseUI';
import type { InnerPanelProps } from '../../content/types';

// eslint-disable-next-line react/prefer-es6-class
export default createReactClass<InnerPanelProps>({
  displayName: 'shoutoutPanel',
  mixins: [core.mixins.editorAPIMixin],
  propTypes: {
    isUserPremium: PropTypes.bool,
    languageCode: PropTypes.string,
    metaSiteId: PropTypes.string.isRequired,
    sitePublicUrl: PropTypes.string,
    siteNameSEO: PropTypes.string,
    siteDescriptionSEO: PropTypes.string,
    isFirstPublish: PropTypes.bool,
    userStatus: PropTypes.string,
  },

  getTitle() {
    return translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_TITLE');
  },

  getPanelContent() {
    const seoWizardAssets = {
      key: 'seo',
      symbol: 'publishSeo',
      description: translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_SEO_TITLE'),
      actionTitle: translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_SEO_LINK'),
      action: this.openSeoWizard,
    };
    const twitterAssets = {
      key: 'twitter',
      symbol: 'publishTwitter',
      description: translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_2_TITLE'),
      actionTitle: translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_2_LINK'),
      action: this.openTwitter,
    };
    const shoutoutAssets = {
      key: 'shoutout',
      symbol: 'publishShoutout',
      description: translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_3_TITLE'),
      actionTitle: translate('PUBLISH_CONGRATULATIONS_WHATS_NEXT_3_LINK'),
      action: this.openShoutout,
    };

    return [seoWizardAssets, twitterAssets, shoutoutAssets];
  },

  openSeoWizard() {
    this.sendSecondPublishBI(
      coreBi.events.publish.Second_Publish_Seo_Wizard_click,
    );
    this.getEditorAPI().account.openWixSEOWiz('EDITOR_POSTPUBLISH');
  },

  openTwitter() {
    this.sendSecondPublishBI(
      coreBi.events.publish.Second_Publish_Twitter_share_click,
    );
    core.utils.social.openTwitter(
      this.props.sitePublicUrl,
      this.props.isUserPremium,
    );
  },

  openShoutout() {
    this.sendSecondPublishBI(
      coreBi.events.publish.Second_Publish_ShoutOut_Share_click,
    );
    core.utils.social.openShoutout(this.props.metaSiteId);
  },

  sendSecondPublishBI(event: AnyFixMe) {
    if (!this.props.isFirstPublish && this.props.userStatus) {
      this.getEditorAPI().bi.event(event, {
        user_status: this.props.userStatus,
      });
    }
  },

  render() {
    return (
      <div className="panel-shout-out">
        <div className="promote-title-wrapper">
          <Divider long={true} />
          <div className="promote-title">{this.getTitle()}</div>
          <Divider long={true} />
        </div>

        <div className="promotion-content">
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line you-dont-need-lodash-underscore/map */}
          {_.map(this.getPanelContent(), (item) => (
            <div key={item.key} className="promote">
              {item.symbol ? (
                <div
                  key={`promotionSymbol-${item.key}`}
                  className={`promote-symbol promote-symbol-${item.key}`}
                >
                  <baseUI.symbol name={item.symbol} />
                </div>
              ) : null}
              {item.img && !item.symbol ? (
                <div
                  key={`promotionImg-${item.key}`}
                  style={{
                    backgroundImage: `url(${item.img})`,
                  }}
                  className="promote-image"
                />
              ) : null}
              <div className="description">{item.description}</div>
              <a onClick={item.action}>{item.actionTitle}</a>
            </div>
          ))}
        </div>
      </div>
    );
  },
});
